import StorageZoneList from '@/components/StorageZone/StorageZoneList'
import StorageZoneForm from '@/components/StorageZone/StorageZoneForm'
import StorageZoneDetail from '@/components/StorageZone/StorageZoneDetail'

let StorageZoneRouter = [{
  path: '/storage_zone',
  name: 'StorageZoneList',
  component: StorageZoneList,
  meta: {
    title: 'Zones de stockage',
    requiresAuth: true,
    authorizations: ['storage-zone_index', 'desktop_access']
  }
}, {
  path: '/storage_zone/new',
  name: 'StorageZoneNew',
  component: StorageZoneForm,
  meta: {
    title: 'Nouvelle zone de stockage',
    requiresAuth: true,
    authorizations: ['storage-zone_new', 'desktop_access']
  }
}, {
  path: '/storage_zone/:id/edit',
  name: 'StorageZoneEdit',
  component: StorageZoneForm,
  meta: {
    title: 'Modifier une zone de stockage',
    requiresAuth: true,
    authorizations: ['storage-zone_edit', 'desktop_access']
  }
}, {
  path: '/storage_zone/:id',
  name: 'StorageZoneDetail',
  component: StorageZoneDetail,
  meta: {
    title: 'Fiche zone de stockage',
    requiresAuth: true,
    authorizations: ['storage-zone_show', 'desktop_access']
  }
}]

export default StorageZoneRouter



// WEBPACK FOOTER //
// ./src/components/StorageZone/router.js